import request from '@/utils/request'; // 复用项目统一的 axios 实例

// 技术需求模块所有接口，统一导出（与成果管理接口风格保持一致）
export default {
    // 技术领域选项（与后端 TechDemand.techField 字段对应，可根据实际业务调整）
    techFields: [
        "其他",
        "生物医药和先进医疗装备",
        "软件和信息技术服务",
        "高品质钢铁材料",
        "优质粮油生产和食品制造",
        "精细化工",
        "新能源",
        "节能环保"
    ],

    // 1. 分页查询全部技术需求
    // params：支持 pageNum（页码）、pageSize（每页条数）
    getList(params) {
        return request({
            url: '/techDemands/',
            method: 'get',
            params // GET 请求参数拼在 URL 后（如 ?pageNum=1&pageSize=12）
        });
    },

    // 2. 根据需求名称模糊查询（分页）
    // params：必填 demandName（需求名称关键词），可选 pageNum、pageSize
    getByDemandName(params) {
        // 校验必填参数
        if (!params?.demandName) {
            console.error("查询失败：需求名称关键词不能为空");
            return Promise.reject(new Error("需求名称关键词不能为空"));
        }
        return request({
            url: '/techDemands/demandName',
            method: 'get',
            params // GET 请求参数拼在 URL 后（如 ?demandName=人工智能&pageNum=1&pageSize=12）
        });
    },

    // 3. 根据技术领域精确查询（分页）
    // params：必填 techField（技术领域），可选 pageNum、pageSize
    getByTechField(params) {
        // 校验必填参数
        if (!params?.techField) {
            console.error("查询失败：技术领域不能为空");
            return Promise.reject(new Error("技术领域不能为空"));
        }
        return request({
            url: '/techDemands/techField',
            method: 'get',
            params // GET 请求参数拼在 URL 后（如 ?techField=生物医药&pageNum=1&pageSize=12）
        });
    },

    // 4. 根据 ID 查询单个技术需求详情
    getById(id) {
        // 校验主键 ID
        if (!id) {
            console.error("查询失败：技术需求 ID 不能为空");
            return Promise.reject(new Error("技术需求 ID 不能为空"));
        }
        return request({
            url: `/techDemands/${id}`, // 路径传参 ID
            method: 'get'
        });
    },

    // 5. 新增技术需求数据（POST 请求，JSON 格式）
    create(demandData) {
        return request({
            url: '/techDemands/',
            method: 'post',
            data: demandData, // 表单数据（含 demandName、techField、demandTypes、demandDesc 等字段）
            headers: {
                'Content-Type': 'application/json' // 明确 JSON 格式（与成果管理接口保持一致）
            }
        });
    },

    // 6. 编辑技术需求数据（PUT 请求，JSON 格式）
    update(demandData) {
        // 校验主键 ID
        if (!demandData?.id) {
            console.error("编辑失败：技术需求 ID 不能为空");
            return Promise.reject(new Error("技术需求 ID 不能为空"));
        }
        return request({
            url: '/techDemands/',
            method: 'put',
            data: demandData // 表单数据（含 id 主键 + 其他修改字段）
        });
    },

    // 7. 删除技术需求数据（DELETE 请求，路径传参）
    delete(id) {
        // 校验主键 ID
        if (!id) {
            console.error("删除失败：技术需求 ID 不能为空");
            return Promise.reject(new Error("技术需求 ID 不能为空"));
        }
        return request({
            url: `/techDemands/${id}`, // 路径拼接 ID
            method: 'delete'
        });
    }
};